import { getRouterInfo } from '@ellf/app-routing';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
export const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const selectLoginForm = createSelector(getAuthState, (s) => s.loginForm);
export const selectLoggedUser = createSelector(
  getAuthState,
  (s) => s.loggedUser,
);

export const selectUserMustResetPassword = createSelector(
  getAuthState,
  (s) => s.userMustResetPassword,
);

export const selectAuthError = createSelector(getAuthState, (s) => s.authError);

export const resetPasswordEmailSent = createSelector(
  getAuthState,
  (s) => s.resetPasswordEmailSent,
);

// export const selectQueryDomain = createSelector(
//   getRouterInfo,
//   (r) => r.queryParams.domainId
// );

export const selectForgotPasswordForm = createSelector(
  getAuthState,
  (s) => s.forgotPasswordForm,
);
export const selectResetPasswordForm = createSelector(
  getAuthState,
  (s) => s.resetPasswordForm,
);

export const selectQueryParams = createSelector(
  getRouterInfo,
  (r) => r.queryParams,
);
